'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utilsFont = require('./utils/font');

var _utilsFont2 = _interopRequireDefault(_utilsFont);

var Box = function Box(props) {

	var style = {};
	if (props.height) style.height = props.height;
	if (props.width) style.width = props.width;

	var textStyle = { position: 'relative' };
	(0, _utilsFont2['default'])(textStyle, props.font);

	if (props.columnCount !== undefined) textStyle.WebkitColumnCount = props.columnCount;

	return _react2['default'].createElement(
		'article',
		{ style: style },
		_react2['default'].createElement('div', { style: textStyle, dangerouslySetInnerHTML: { __html: props.content } })
	);
};

Box.defaultProps = { content: 'type your content' };
exports['default'] = Box;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/ArticleContent.js
 ** module id = 2215
 ** module chunks = 0
 **/